<div class="row">
  <div class="col-lg-2" style="background-color: #F2F2F2">
    <app-admin-menu></app-admin-menu>
  </div>
  <div class="col-lg-10" style="padding-top: 54px;">
    <div class="">
      <div class="admin-main-container-content">
        @if (actionPeriod.id) {
          <div style="margin-left: 5px" class="header-title">{{'' | i18n: 'edit-action'}}</div>
        }
        @if (!actionPeriod.id) {
          <div class="header-title">{{'' | i18n: 'new-action'}}</div>
        }
        <div class="main-container">
          <div class="col-lg-6" style="margin-left: -30px;">
            <div class="row" style="margin-left: 0px;">
              <div class="col-lg-6">
                <div class="form-group">
                  <label>{{'' | i18n: 'dealer-region'}}:</label>
                  <ng-multiselect-dropdown
                    [placeholder]="'Select Region...'"
                    [data]="regions"
                    [(ngModel)]="actionPeriod.selectedRegions"
                    (ngModelChange)="selectAllDealersInSelectedRegions()"
                    [settings]="dropdownSettings">
                  </ng-multiselect-dropdown>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group" style="margin-left: -10px;">
                  <label>{{'' | i18n: 'vins-dealer'}}(s):</label>
                  <ng-multiselect-dropdown
                    [placeholder]="'Select Dealers...'"
                    [data]="dealers"
                    [(ngModel)]="actionPeriod.selectedDealers"
                    [settings]="dropdownSettings">
                  </ng-multiselect-dropdown>
                </div>
              </div>
            </div>
            <div style="display: flex;">
              <div class="col-lg-6">
                <div class="form-group">
                  <label>{{'' | i18n: 'brand'}}*:</label>
                  <select [(ngModel)]="actionPeriod.selectedBrand" (ngModelChange)="fetchContractTypes()">
                    <option value="{{null}}">{{'' | i18n: 'select'}}</option>
                    <option value="BMW">BMW</option>
                    <option value="MINI">MINI</option>
                    @if (displayBMWi) {
                      <option value="BMWi">BMWi</option>
                    }
                    <option value="Motorrad">Motorrad</option>
                  </select>
                  @if (!isValid()) {
                    <app-error-field [errorMessage]="'please-select-a-brand'"></app-error-field>
                  }
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label>{{'' | i18n: 'model'}}:</label>
                  <ng-multiselect-dropdown
                    [placeholder]="'Select Models...'"
                    [data]="models"
                    [(ngModel)]="actionPeriod.selectedModels"
                    [settings]="dropdownSettings">
                  </ng-multiselect-dropdown>
                </div>
              </div>
            </div>
            <div style="display: flex;">
              <div class="col-lg-6">
                <div class="form-group">
                  <label>{{'' | i18n: 'contract-type'}}:</label>
                  <select #contractType id="warranty-contract-TypeId" [(ngModel)]="actionPeriod.selectedContractType"
                    (ngModelChange)="setContractDurations()">
                    <option value="null">{{'' | i18n: 'select'}}</option>
                    @for (c of contractTypes; track c) {
                      <option [ngValue]="c">{{  c.contractType }}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label>{{'' | i18n: 'contract-duration'}}:</label>
                  @if (actionPeriod.selectedContractType) {
                    <select #contractCode id="warranty-contract-DurationId"
                      [(ngModel)]="actionPeriod.selectedContractCode">
                      <option value="null">{{'' | i18n: 'select'}}</option>
                      @for (c of actionPeriod.selectedContractType.contractCodes; track c) {
                        <option
                        value="{{c.code}}">{{c.period + ' Months'}}</option>
                      }
                    </select>
                  }
                  @if (!actionPeriod.selectedContractType) {
                    <select id="warranty-contract-"
                      [(ngModel)]="actionPeriod.selectedContractCode">
                      <option value="null">{{'' | i18n: 'select'}}</option>
                    </select>
                  }
                </div>
              </div>
            </div>
            <div class="row" style="margin-left: 0px;">
              <div class="col-lg-6">
                <div class="form-group">
                  <label>{{'' | i18n: 'order-date-from'}}:</label>
                  <input type="date" [(ngModel)]="actionPeriod.dateFrom">
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label>{{'' | i18n: 'order-date-to'}}:</label>
                  <input type="date" [(ngModel)]="actionPeriod.dateTo">
                </div>
              </div>
            </div>
            <div class="row" style="margin-left: 0px;">
              <div class="col-lg-6">
                <div class="form-group">
                  <label>{{'' | i18n: 'creation-date-from'}}:</label>
                  <input type="date" [(ngModel)]="actionPeriod.warrantyCreationDateFrom">
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label>{{'' | i18n: 'creation-date-to'}}:</label>
                  <input type="date" [(ngModel)]="actionPeriod.warrantyCreationDateTo">
                </div>
              </div>
            </div>
            <div class="row" style="margin-left: 0px;">
              <div class="col-lg-12">
                <div class="form-group">
                  <label>{{'' | i18n: 'vins-applicable'}}:</label>
                  <textarea [(ngModel)]="vinList"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="button_bottom">
          <button class="btn-default-custon" (click)="goBack()">{{'' | i18n: 'cancel'}}</button>
          @if (actionPeriod.id) {
            <button (click)="deleteActionPeriod()">{{'' | i18n: 'delete'}}</button>
          }
          <button (click)="saveActionPeriod()" [disabled]="!isValid()">{{'' | i18n: 'save'}}</button>
        </div>
      </div>
    </div>
  </div>
</div>



